import { Network } from '../../../../utils/network'
import { Events } from '../../../../utils/servicesEvents'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function getRiders(onSuccessEvent, onErrorEvent) {
  const response = await sendRequest()
  const parsedResponse = parseResponse(response, Formatter)
  const onDoneEvent = parsedResponse.success ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest() {
  const storeId = await self.servicesVars.getStoreId()
  const url = `${urls.getRiders}${storeId}`
  const response = await Network.sendGetRequest(url)
  return response
}

function parseResponse(response) {
  if (
    response &&
    response.status.code === 200 &&
    response?.response?.statusCode == 200
  ) {
    const rawData = response.response.data
    const appData = Formatter.parseExternalRiders(rawData)

    return {
      success: true,
      data: appData,
    }
  }
  if (
    response &&
    response.status.code === 404 &&
    response.response?.statusCode == 404
  ) {
    const appData = Formatter.parseExternalRiders([])

    return {
      success: true,
      data: appData,
    }
  }
  if (response === null || response.status.code === 401) {
    return {
      success: false,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { getRiders }
